module.exports = __webpack_public_path__ + "img/offers2.3b7ce156.png";